import Ornement from './Ornement';

export default Ornement;
